import { CSSProperties } from 'react';
import ArrowDown from '~/images/arrowDown.svg';
import ArrowUp from '~/images/arrowUp.svg';
import Arrows from '~/images/sortArrows.svg';

interface IProps {
  sorting: {
    direction: 'asc' | 'desc' | string;
    field: string;
  };
  value: string;
}

export const SortingArrow = ({ sorting, value }: IProps) => {
  if (value !== sorting.field) {
    return <img src={Arrows} alt="sort_arrow" style={styles} />;
  }

  if (sorting.direction === 'asc') {
    return <img src={ArrowUp} alt="sort_arrow" style={styles} />;
  }

  return <img src={ArrowDown} alt="sort_arrow" style={styles} />;
};

const styles: CSSProperties = {
  marginLeft: 8,
  width: 10,
};
